import { isAndroid, isIOS } from "react-device-detect";

export const getDeviceOS = () =>
  isAndroid ? "android" : isIOS ? "ios" : "other";
